import React, { useEffect, useRef } from 'react'

import { useLocation, useRoutes } from 'react-router-dom'
import { Routes } from 'routes'
import { ScrollReveal } from 'shared/utils'

export default function App(): JSX.Element {
  const element = useRoutes(Routes())
  const childRef = useRef<any>()
  const location = useLocation()

  useEffect(() => {
    document.body.classList.add('is-loaded')
    childRef.current?.init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return <ScrollReveal ref={childRef} children={() => <>{element}</>} />
}
